import React from "react";
import { Input } from "../../../design/input";
import { Select } from "../../../design/select";
import { Button } from "../../../design/button";
import { XMarkIcon } from "@heroicons/react/20/solid";
import { ProgramType, PROGRAM_TYPE_LABELS } from "@visitproof/types";

type FilterStatus = "all" | "open" | "closed";

interface CaseFiltersProps {
  searchTerm: string;
  statusFilter: FilterStatus;
  programTypeFilter: ProgramType | "all";
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onStatusChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onProgramTypeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onClearFilters: () => void;
  hasActiveFilters: boolean;
}

const CaseFilters: React.FC<CaseFiltersProps> = ({
  searchTerm,
  statusFilter,
  programTypeFilter,
  onSearchChange,
  onStatusChange,
  onProgramTypeChange,
  onClearFilters,
  hasActiveFilters,
}) => {
  return (
    <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      {/* Search and Status Filters */}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
        {/* Search Input */}
        <div className="relative flex-1 sm:max-w-sm">
          <Input
            type="search"
            placeholder="Search cases..."
            value={searchTerm}
            onChange={onSearchChange}
          />
        </div>

        {/* Status Filter */}
        <Select
          name="status"
          value={statusFilter}
          onChange={onStatusChange}
          className="sm:w-40"
        >
          <option value="all">All Status</option>
          <option value="open">Open</option>
          <option value="closed">Closed</option>
        </Select>

        {/* Program Type Filter */}
        <Select
          name="programType"
          value={programTypeFilter}
          onChange={onProgramTypeChange}
          className="sm:w-48"
        >
          <option value="all">All Programs</option>
          {Object.entries(PROGRAM_TYPE_LABELS).map(([value, label]) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </Select>
      </div>

      {/* Clear Filters Button */}
      {hasActiveFilters && (
        <Button
          plain
          onClick={onClearFilters}
          className="flex items-center gap-2 text-zinc-600 hover:text-zinc-800 dark:text-zinc-400 dark:hover:text-zinc-200"
        >
          <XMarkIcon className="w-4 h-4" />
          Clear filters
        </Button>
      )}
    </div>
  );
};

export default CaseFilters; 